import { Link } from "react-router-dom";
import { SITE_LOGO_URL } from "@/lib/seo";

interface LogoProps {
  /** Sobre fondos oscuros aplica una sombra suave para garantizar contraste. */
  light?: boolean;
  className?: string;
  size?: "sm" | "md" | "lg";
  /** Clase de altura de Tailwind que reemplaza a `size` (permite animar el tamaño). */
  heightClass?: string;
  imgClassName?: string;
  /** Activa la transición suave de tamaño (usada por la barra al hacer scroll). */
  transition?: boolean;
  /** Coloca el logo sobre un cuadro blanco para mejorar su visibilidad. */
  boxed?: boolean;
}

const sizeClasses: Record<NonNullable<LogoProps["size"]>, string> = {
  sm: "h-8",
  md: "h-10",
  lg: "h-14",
};

export default function Logo({
  className = "",
  size = "md",
  heightClass,
  imgClassName = "",
  transition = false,
  boxed = false,
}: LogoProps) {
  const height = heightClass ?? sizeClasses[size];

  return (
    <Link
      to="/"
      className={`group inline-flex items-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 ${
        boxed ? "rounded-lg bg-white px-2.5 py-1.5 ring-1 ring-black/10" : "rounded-md"
      } ${className}`}
      aria-label="AXONIA GROUP — Inicio"
    >
      <img
        src={SITE_LOGO_URL}
        alt="Axonia Group"
        width={960}
        height={640}
        className={`${height} w-auto object-contain ${transition ? "transition-all duration-300 ease-out" : ""} ${imgClassName}`}
      />
    </Link>
  );
}